<div class="financeiro-page">
  <div class="header d-flex justify-content-between align-items-center flex-wrap gap-2">
    <div>
      <h1>Gerar Boleto</h1>
      <p class="text-muted small mb-0">
        Configure a API em
        <a routerLink="/configuracao-cnab-santander">Configuração API Santander</a>
        ou
        <a routerLink="/configuracao-api-banrisul">Configuração API Banrisul</a>
        (empresa cedente fixa: ID 2). Os títulos listados abaixo são sempre da empresa ID 1.
      </p>
    </div>
  </div>

  <div class="card-box mb-3 filtros-boleto">
    <div class="row g-2 mb-2">
      <div class="col-md-8">
        <label class="form-label">Nome (pagador)</label>
        <input
          type="text"
          class="form-control form-control-sm"
          [(ngModel)]="filtroNomePagador"
          placeholder="Trecho do nome (contém o texto em qualquer posição)"
        />
      </div>
    </div>

    <p class="filtros-data-periodos__legenda small text-muted mb-2">Períodos (deixe em branco para ignorar)</p>
    <div class="row g-2 filtros-data-periodos">
      <div class="col-lg-4 col-md-6">
        <div class="filtro-data-grupo">
          <div class="filtro-data-grupo__titulo">Emissão</div>
          <div class="row g-1">
            <div class="col-6">
              <label class="form-label form-label-sm mb-0">Inicial</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filtroDataEmissaoInicio" />
            </div>
            <div class="col-6">
              <label class="form-label form-label-sm mb-0">Final</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filtroDataEmissaoFim" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="filtro-data-grupo">
          <div class="filtro-data-grupo__titulo">Vencimento</div>
          <div class="row g-1">
            <div class="col-6">
              <label class="form-label form-label-sm mb-0">Inicial</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filtroDataVencimentoInicio" />
            </div>
            <div class="col-6">
              <label class="form-label form-label-sm mb-0">Final</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filtroDataVencimentoFim" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="filtro-data-grupo">
          <div class="filtro-data-grupo__titulo">Recebimento</div>
          <div class="row g-1">
            <div class="col-6">
              <label class="form-label form-label-sm mb-0">Inicial</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filtroDataRecebimentoInicio" />
            </div>
            <div class="col-6">
              <label class="form-label form-label-sm mb-0">Final</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filtroDataRecebimentoFim" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-2 mt-1">
      <div class="col-md-3">
        <label class="form-label">Tipo recebimento</label>
        <select class="form-control form-control-sm" [(ngModel)]="filtroIdTipoRecebimento">
          <option [ngValue]="0">Todos</option>
          <option *ngFor="let t of tiposRecebimento" [ngValue]="t.id">{{ t.descricao }}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label">Boleto gerado</label>
        <select class="form-control form-control-sm" [(ngModel)]="filtroBoletoGerado">
          <option [ngValue]="'T'">Todos</option>
          <option [ngValue]="'S'">Sim</option>
          <option [ngValue]="'N'">Não</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label">Observações</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filtroObservacao" />
      </div>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-2">
      <button type="button" class="btn btn-primary btn-sm" [disabled]="loading" (click)="carregar()">
        <i class="fa fa-search"></i> Buscar
      </button>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="limparFiltros()">
        <i class="fa fa-eraser"></i> Limpar filtros
      </button>
    </div>
    <p class="text-muted small mb-0 mt-2">
      Por padrão são listados os títulos <strong>não pagos</strong>. Use <strong>Registrar no Santander</strong> ou
      <strong>Registrar no Banrisul</strong> para enviar à API e imprimir o boleto.
      <strong>Consultar pagamento</strong> verifica liquidação no banco e baixa automaticamente (Santander ou Banrisul).
    </p>
  </div>

  <div class="card-box table-wrap">
    <div *ngIf="loading && !itens.length" class="text-muted py-3">Carregando...</div>

    <div class="table-actions-left d-flex flex-wrap gap-2" *ngIf="itens.length || !loading">
      <button type="button" class="btn btn-success btn-sm" [disabled]="!selecionados.size" (click)="registrarBoletos()">
        <i class="fa fa-bank"></i> Registrar no Santander
      </button>
      <button type="button" class="btn btn-info btn-sm text-white" [disabled]="!selecionados.size" (click)="registrarBanrisul()">
        <i class="fa fa-bank"></i> Registrar no Banrisul
      </button>
      <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="!selecionados.size" (click)="consultarPagamentoSantander()">
        <i class="fa fa-search"></i> Consultar pagamento (Santander)
      </button>
      <button type="button" class="btn btn-outline-info btn-sm" [disabled]="!selecionados.size" (click)="consultarPagamentoBanrisul()">
        <i class="fa fa-search"></i> Consultar pagamento (Banrisul)
      </button>
      <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="!selecionados.size" (click)="preVisualizarBoletos()">
        <i class="fa fa-eye"></i> Pré-visualizar
      </button>
      <button type="button" class="btn btn-outline-warning btn-sm" [disabled]="loading" (click)="emularBoletoV2()">
        <i class="fa fa-file-text-o"></i> Emular boleto (novo modelo V2)
      </button>
    </div>

    <div class="table-responsive" *ngIf="itens.length || !loading">
      <table class="table table-striped table-sm table-hover align-middle mb-0">
        <thead>
          <tr>
            <th class="col-check">
              <input type="checkbox" [checked]="todosDaPaginaSelecionados" (change)="toggleTodosPagina()" title="Selecionar página" />
            </th>
            <th>#</th>
            <th>Nosso nº</th>
            <th>Pago por</th>
            <th>Parcela</th>
            <th>Emissão</th>
            <th>Vencimento</th>
            <th>Recebimento</th>
            <th>Valor título</th>
            <th>Valor recebido</th>
            <th>Boleto</th>
            <th>Reg. banco</th>
            <th>Documento</th>
            <th>Tipo recebimento</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!itensPaginados.length && !loading">
            <td colspan="14" class="text-center text-muted py-3">Nenhuma conta a receber encontrada.</td>
          </tr>
          <tr *ngFor="let item of itensPaginados; let i = index">
            <td class="col-check">
              <input type="checkbox" [checked]="isSelecionado(item.id)" (change)="toggleSelecionado(item.id)" />
            </td>
            <td>{{ (paginaAtual - 1) * itensPorPagina + i + 1 }}</td>
            <td>{{ item.nossoNumero || '-' }}</td>
            <td>{{ item.usuarioPagador || '-' }}</td>
            <td>{{ item.parcela || '-' }}</td>
            <td>{{ item.dataEmissao }}</td>
            <td>{{ item.dataVencimento }}</td>
            <td>{{ item.dataRecebimento }}</td>
            <td>{{ formatMoney(item.valorDocumento) }}</td>
            <td>{{ formatMoney(item.valorRecebido) }}</td>
            <td>{{ simNao(item.boletoGerado) }}</td>
            <td>{{ simNao(item.boletoRegistradoApi) }}</td>
            <td>{{ item.finDocumento || '-' }}</td>
            <td>{{ item.tipoRecebimento || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-bar d-flex flex-wrap align-items-center justify-content-between gap-2 mt-3" *ngIf="itens.length">
      <span class="text-muted small">
        {{ itens.length }} registro(s) — página {{ paginaAtual }} de {{ totalPaginas }}
        <span *ngIf="selecionados.size"> — {{ selecionados.size }} selecionado(s)</span>
      </span>
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <label class="small mb-0">Por página</label>
        <select class="form-control form-control-sm" style="width: 72px" [(ngModel)]="itensPorPagina" (ngModelChange)="alterarItensPorPagina()">
          <option [ngValue]="10">10</option>
          <option [ngValue]="15">15</option>
          <option [ngValue]="25">25</option>
          <option [ngValue]="50">50</option>
        </select>
        <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="paginaAtual <= 1" (click)="paginaAnterior()">
          <i class="fa fa-chevron-left"></i>
        </button>
        <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="paginaAtual >= totalPaginas" (click)="proximaPagina()">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="modal-observacao-backdrop" *ngIf="modalObservacaoAberto" (click)="fecharModalObservacao()">
    <div class="modal-observacao card-box" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
      <div class="d-flex justify-content-between align-items-start gap-2 mb-2">
        <div>
          <h2 class="h6 mb-1">{{ tituloModalObservacao }}</h2>
          <p class="text-muted small mb-0">
            Edite as observações que aparecerão nas instruções do boleto. O texto é salvo no título antes da geração.
          </p>
        </div>
        <button type="button" class="btn-close" aria-label="Fechar" (click)="fecharModalObservacao()"></button>
      </div>

      <div class="modal-observacao__lista">
        <div class="modal-observacao__item" *ngFor="let item of observacoesEdicao">
          <div class="modal-observacao__item-header">
            <strong>#{{ item.id }}</strong>
            <span>{{ item.usuarioPagador }}</span>
            <span *ngIf="item.parcela">· Parcela {{ item.parcela }}</span>
            <span *ngIf="item.valorDocumento != null">· {{ formatMoney(item.valorDocumento) }}</span>
          </div>
          <textarea
            class="form-control form-control-sm"
            rows="4"
            [(ngModel)]="item.observacao"
            placeholder="Instruções / descrição do serviço (multilinha)"
          ></textarea>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-3">
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="fecharModalObservacao()">
          Cancelar
        </button>
        <button type="button" class="btn btn-primary btn-sm" (click)="confirmarObservacaoEGerar()">
          Confirmar e gerar
        </button>
      </div>
    </div>
  </div>
</div>
